/* eslint-disable @typescript-eslint/no-explicit-any */

import { Dispatch } from 'redux';

import _ from 'lodash';

import {
  navigateToMember,
  navigateToSection,
  navigateToMembersPage,
  getNavigatableRoles,
  openFFLightbox,
} from '../../services/wix-sdk-utils';
import { getConfig } from '../../services/config';
import { getGlobalSettings } from '../../selectors/settings-selectors';
import { openInternalUrlAsModal } from '../../actions/open-modal';
import { PAGE_TYPE } from '../ff-page/constants';
import { getIsMobile } from '../site/selectors';
import { exitModal } from '../ff-page/actions';
import { getMember } from '../members/selectors';

const FF_COMPONENT_ID = 'following_followers';
const FOLLOWERS_FOLLOWING_WIDGET_ID = '14ebe825-b273-0d5f-0fd1-e6293322b83b';

export const goToMemberPage = (memberId: string) => async (dispatch: Dispatch<any>, getState: () => any) => {
  const member = getMember(getState(), memberId);
  const { navigatableMembersRoles } = await getNavigatableRoles();
  if (!navigatableMembersRoles?.length || _.intersection(navigatableMembersRoles, member?.roles).length > 0) {
    await navigateToMember(memberId, member.slug);
    if (getIsMobile(getState())) {
      dispatch(exitModal());
    }
  }
};

export const goToFFPage = (memberId: string, followers: boolean) => async (
  dispatch: Dispatch<any>,
  getState: () => any,
) => {
  if (getGlobalSettings(getState()).ffLightboxInstalled) {
    const viewedMember = getMember(getState(), memberId);

    return openFFLightbox({
      title: viewedMember.name,
      memberId: viewedMember.uid,
      activeTab: followers ? 'followers' : 'following',
    });
  }

  const tpaInnerRoute = followers ? PAGE_TYPE.FOLLOWERS : PAGE_TYPE.FOLLOWING;
  const path = followers ? `app/ff/${PAGE_TYPE.FOLLOWERS}` : `app/ff/${PAGE_TYPE.FOLLOWING}`;
  const verticals = getConfig().verticals || {};
  return getIsMobile(getState())
    ? dispatch(
        openInternalUrlAsModal(path, undefined, undefined, {
          viewedUser: memberId,
        }),
      )
    : navigateToSection({
        appDefinitionId: verticals.membersFF,
        sectionId: FF_COMPONENT_ID,
        memberId,
        tpaInnerRoute,
        widgetId: FOLLOWERS_FOLLOWING_WIDGET_ID,
      });
};

export const goToMembersPage = (params?: Record<'badgeId', string>) => () => {
  navigateToMembersPage(params);
};
